import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icons/quit.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "page-wrapper" }
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 1,
  class: "dropdown-container"
}
const _hoisted_6 = {
  class: "dropdown",
  id: "dropdownUser",
  role: "button",
  "aria-expanded": "false"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  class: "btn dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_10 = { class: "img-wrapper" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Settings", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "main-wrapper" }
const _hoisted_17 = {
  key: 0,
  class: "row"
}
const _hoisted_18 = {
  key: 0,
  class: "mx-auto col-xl-4 col-12"
}
const _hoisted_19 = {
  key: 1,
  class: "row mt-5"
}
const _hoisted_20 = {
  key: 0,
  class: "modal-join"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  style: {"cursor":"pointer","width":"20px","height":"20px"},
  src: _imports_0
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "content" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "modal_title" }, "Interseted in UGC? Join content factory ", -1)
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  style: {"cursor":"pointer","width":"20px","height":"20px"},
  src: _imports_0
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "modal__title" }, "Account Settings", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_SideNavBar = _resolveComponent("SideNavBar")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_SideCards = _resolveComponent("SideCards")!
  const _component_SearchFilters = _resolveComponent("SearchFilters")!
  const _component_ProfileNotValid = _resolveComponent("ProfileNotValid")!
  const _component_account_setting_modal = _resolveComponent("account-setting-modal")!
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!
  const _component_InfluencerOnboardingQuestions = _resolveComponent("InfluencerOnboardingQuestions")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "page-container",
      class: _normalizeClass({
      'active-sidenav': _ctx.isActiveSideNav,
      'container-border-staging': _ctx.node_env != 'prod',
    })
    }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Spinner)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createVNode(_component_SideNavBar, {
                modelValue: _ctx.openModal,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openModal) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  id: _ctx.openJoinUse ? 'top-inside-navbar' : 'top-navbar',
                  class: "d-flex"
                }, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSideNav && _ctx.toggleSideNav(...args))),
                    class: "sidenav-toggle"
                  }, [
                    _createVNode(_component_inline_svg, {
                      src: require('@/assets/images/icons/toggle-menu.svg')
                    }, null, 8, ["src"])
                  ]),
                  (_ctx.goToTCF)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirectToTCF())),
                        style: {"width":"196px","height":"fit-content","padding":"6px","align-self":"center","background-color":"#9100ff","border-color":"transparent","border-radius":"11px","font-size":"12px","font-weight":"bold","color":"white"}
                      }, " Discover UGC Opportunities "))
                    : _createCommentVNode("", true),
                  (_ctx.userInfo.isPublicAccess == false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.userInfo.fullname), 1),
                          (_ctx.userInfo.isLegacy == true && _ctx.userInfo.advertiser)
                            ? (_openBlock(), _createElementBlock("strong", _hoisted_7, ": " + _toDisplayString(_ctx.userInfo.advertiser.name), 1))
                            : _createCommentVNode("", true),
                          (_ctx.userInfo.isLegacy == true && _ctx.userInfo.influencer)
                            ? (_openBlock(), _createElementBlock("strong", _hoisted_8, ": " + _toDisplayString(_ctx.userInfo.influencer.first_name ||
                    _ctx.userInfo.influencer.last_name
                      ? _ctx.userInfo.influencer.first_name +
                        _ctx.userInfo.influencer.last_name
                      : _ctx.userInfo.influencer.influencer_name), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("img", {
                              src: _ctx.picUrl,
                              alt: _ctx.userInfo.fullname,
                              class: "img-profile"
                            }, null, 8, _hoisted_11)
                          ])
                        ]),
                        _createElementVNode("ul", _hoisted_12, [
                          (_ctx.userInfo.isLegacy == false)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                                _createElementVNode("a", {
                                  id: "setting-link",
                                  class: "dropdown-item",
                                  role: "button",
                                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openSettingsModal && _ctx.openSettingsModal(...args)))
                                }, _hoisted_15)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            _createElementVNode("div", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                href: "#",
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logoutHandler && _ctx.logoutHandler(...args)))
                              }, "Logout")
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_4),
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.readIsCompleted && _ctx.readIsValidated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", {
                          class: _normalizeClass([{
                  'col-xl-8':
                    !_ctx.isTalent &&
                    _ctx.$route.matched.some(
                      ({ name }) =>
                        ![
                          'home',
                          'influencerDetails',
                          'FreemiumUpdateProfile',
                          'inbox',
                          'Shortlists',
                          'Campaign agency',
                          'campaignDetails',
                          'editCampaign',
                          'AdvertiserQuotes',
                          'AdvertiserQuoteDetails',
                          'AdvertiserApplications',
                          'ApplicationDetails',
                          'AdvertiserContracts',
                          'AdvertiserBriefs',
                          'AdvertiserPlanning',
                          'ContentReviewList',
                          'ContentReview',
                          'AdvertiserCampaignsTracking',
                          'AdvertiserCampaignEvents',
                          'AdvertiserEventContentsStats',
                          'AdvertiserMediaStatsDetails',
                          'ContentReviewCampaignsList',
                          'AdvertiserCampaignQuotes',
                          'AdvertiserCampaignApplications',
                          'AdvertiserCampaignContracts',
                          'AdvertiserCampaignBriefs',
                          'AdvertiserCampaignPlanning',
                          'AdvertiserCampaignContent',
                          'AdvertiserCampaignContentOfCreator',
                          'AdvertiserCampaignPerformance',
                          'AdvertiserPerformance',
                          'AdvertiserCampaignTracking',
                          'AdvertiserCampaignsPerformance',
                          'CollaborationPerformance',
                          'CampignTrackingInfluncers',
                          'CampignStatisicsnfluncers',
                          'AdvertiserCampaignStatistics',
                          'AdvertiserCampaignStatisticsPerCreator',
                          'AdvertiserCampaignContentOfEvent',
                          'AdvertiserCampaignStatisticsOfEvent',
                          'AdvertiserCampaignStatisticsOfEventMedia',
                          'AdvertiserCampaignQuoteDetails',
                          'AdvertiserCampaignApplicationDetails',
                          'AdvertiserCampaignBriefDetails',
                          'AdvertiserCampaignBriefEdit',
                          'AdvertiserNotificationsCenter',
                          'InfluencerCollaborationDetails',
                          'InfluencerCollaborationQuote',
                          'InfluencerCollaborationContract',
                          'InfluencerCollaborationBrief',
                          'InfluencerCollaborationPlanning',
                          'InfluencerCollaborationContent',
                          'InfluencerCollaborationContentOfEvent',
                          'InfluencerCollaborationStatistics',
                          'CollaborationPerformance',
                          'CollaborationTracking',
                          'InfluencerCollaborationStatisticsOfEvent',
                          'InfluencerCollaborationStatisticsOfEventMedia',
                        ].includes(String(name))
                    ),
                }, "col-12"])
                        }, [
                          _createVNode(_component_router_view)
                        ], 2),
                        (
                  ((_ctx.readUserInfo?.role === 'AGENCY' ||
                    _ctx.readUserInfo?.role === 'BRAND') &&
                    _ctx.$route.matched.some(({ name }) => name !== 'search')) ||
                  ((_ctx.readUserInfo?.role === 'AGENCY' ||
                    _ctx.readUserInfo?.role === 'BRAND') &&
                    _ctx.$route.matched.some(({ name }) => name === 'search') &&
                    _ctx.read_max_search_count - _ctx.read_search_request > 0)
                )
                          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_SideCards),
                              (
                    _ctx.$route.matched.some(
                      ({ name }) => name === 'search' || name === 'discover'
                    ) && _ctx.isSearchHandled
                  )
                                ? (_openBlock(), _createBlock(_component_SearchFilters, {
                                    key: 0,
                                    class: "d-xl-block d-lg-none d-md-none d-sm-none d-xs-none d-xxs-none"
                                  }))
                                : _createCommentVNode("", true)
                            ], 512)), [
                              [_vShow, 
                  _ctx.$route.matched.some(
                    ({ name }) =>
                      ![
                        'home',
                        'influencerDetails',
                        'inbox',
                        'Shortlists',
                        'Campaign agency',
                        'campaignDetails',
                        'editCampaign',
                        'AdvertiserQuotes',
                        'AdvertiserQuoteDetails',
                        'AdvertiserApplications',
                        'ApplicationDetails',
                        'AdvertiserContracts',
                        'AdvertiserBriefs',
                        'AdvertiserPlanning',
                        'ContentReviewList',
                        'ContentReview',
                        'AdvertiserCampaignsTracking',
                        'CampignTrackingInfluncers',
                        'CampignStatisicsnfluncers',
                        'AdvertiserCampaignEvents',
                        'AdvertiserEventContentsStats',
                        'AdvertiserMediaStatsDetails',
                        'ContentReviewCampaignsList',
                        'AdvertiserCampaignQuotes',
                        'AdvertiserCampaignApplications',
                        'CollaborationPerformance',
                        'AdvertiserCampaignContracts',
                        'AdvertiserCampaignBriefs',
                        'AdvertiserCampaignPlanning',
                        'AdvertiserCampaignContent',
                        'AdvertiserCampaignContentOfCreator',
                        'AdvertiserCampaignPerformance',
                        'AdvertiserCampaignTracking',
                        'AdvertiserCampaignsPerformance',
                        'AdvertiserPerformance',
                        'AdvertiserCampaignStatistics',
                        'AdvertiserCampaignStatisticsPerCreator',
                        'AdvertiserCampaignContentOfEvent',
                        'AdvertiserCampaignStatisticsOfEvent',
                        'AdvertiserCampaignStatisticsOfEventMedia',
                        'AdvertiserCampaignQuoteDetails',
                        'AdvertiserCampaignApplicationDetails',
                        'AdvertiserCampaignBriefDetails',
                        'AdvertiserCampaignBriefEdit',
                        'AdvertiserNotificationsCenter',
                        'InfluencerCollaborationDetails',
                        'InfluencerCollaborationQuote',
                        'InfluencerCollaborationContract',
                        'InfluencerCollaborationBrief',
                        'InfluencerCollaborationPlanning',
                        'InfluencerCollaborationContent',
                        'InfluencerCollaborationContentOfEvent',
                        'InfluencerCollaborationStatistics',
                        'CollaborationPerformance',
                        'CollaborationTracking',
                        'InfluencerCollaborationStatisticsOfEvent',
                        'InfluencerCollaborationStatisticsOfEventMedia',
                      ].includes(String(name))
                  )
                ]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(_component_ProfileNotValid, {
                          modelValue: _ctx.openModal,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.openModal) = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                ])
              ])
            ]),
            (_ctx.openJoinUse === true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "modal_close",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeTCFsugg('join')))
                  }, _hoisted_22),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("a", {
                      class: "buuton_join",
                      href: `${_ctx.tcf_auth}joinus?token=${_ctx.userInfo?.tcf_invitation_token}`,
                      target: "_blank"
                    }, "Join Us", 8, _hoisted_25)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.openModal)
              ? (_openBlock(), _createBlock(_component_vue_final_modal, {
                  key: 1,
                  modelValue: _ctx.openModal,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.openModal) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "modal__close",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModal = false))
                    }, _hoisted_27),
                    _hoisted_28,
                    _createVNode(_component_account_setting_modal)
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])),
      (_ctx.isActiveSideNav)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "sidebar-overlay",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleSideNav && _ctx.toggleSideNav(...args)))
          }))
        : _createCommentVNode("", true),
      (_ctx.isTalent)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "moadal__overlay",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleSideNav && _ctx.toggleSideNav(...args)))
          }))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.openOnboardingModal)
      ? (_openBlock(), _createBlock(_component_vue_final_modal, {
          key: 0,
          classes: ['modal-onboarding'],
          modelValue: _ctx.openOnboardingModal,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.openOnboardingModal) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InfluencerOnboardingQuestions, {
              onCloseModal: _ctx.closeOnboardingModal,
              is_modal_open: _ctx.openOnboardingModal
            }, null, 8, ["onCloseModal", "is_modal_open"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}